export default "__VITE_ASSET__Ciob$z4p__"